import { rem } from 'polished'
import { memo } from 'react'
import styled from 'styled-components'
import DropdownChevron from '../../../../LuxKit/Dropdown/DropdownChevron'
import CheckboxInput from 'LuxKit/Checkbox/CheckboxInput'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
import Group from 'components/utils/Group'
import VerticalSpacer from '../Spacing/VerticalSpacer'
import LoadingBox from 'components/Common/Loading/LoadingBox'

const FilterPanel = styled(VerticalSpacer)`
  border-bottom: 1px solid ${props => props.theme.palette.neutral.default.five};
  padding-bottom: ${rem(16)};
`

const FilterGroupLoader = styled(Group)`
  padding: ${rem(16)} 0;

  >:first-child {
    flex-grow: 1;
  }
`

interface Props {
  type: 'checkbox' | 'slider'
}

function FilterPanelLoader(props: Props) {
  const { type } = props

  return <FilterPanel gap={12}>
    <FilterGroupLoader direction="horizontal" horizontalAlign="space-between" gap={8}>
      <TextLoadingBox typography="heading5" width="100%" />
      <DropdownChevron open />
    </FilterGroupLoader>
    {type === 'checkbox' && <VerticalSpacer gap={12}>
      <CheckboxInput size="large"><TextLoadingBox width="100%" /></CheckboxInput>
      <CheckboxInput size="large"><TextLoadingBox width="100%" /></CheckboxInput>
      <CheckboxInput size="large"><TextLoadingBox width="100%" /></CheckboxInput>
    </VerticalSpacer>}
    {type === 'slider' && <VerticalSpacer gap={12}>
      <LoadingBox height={24} />
      <Group direction="horizontal" horizontalAlign="stretch" gap={8}>
        <LoadingBox height={48} />
        <LoadingBox height={48} />
      </Group>
    </VerticalSpacer>}
  </FilterPanel>
}

export default memo(FilterPanelLoader)
